import { IGetZiplogInfoParams } from './GetZiplogInfoRequest';
import { Request } from './Request';

export interface IRebuildSearchIndexParams {
}

export interface IRebuildSearchIndexResult {
  // If no action id is returned, then there is a job already in progress
  actionId?: string;
}

export class RebuildSearchIndexRequest extends Request<IRebuildSearchIndexParams, IRebuildSearchIndexResult> {
  constructor(params: IGetZiplogInfoParams = {}) {
    super('rebuildSearchIndex', params);
  }
}
